import styled from 'styled-components';
export const Button = styled.button `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  
  svg {
    height: 2.1rem;
    width: 2.1rem;
    
    use {
      fill: #01ACEA;
    }
  }
`;
export const Input = styled.input `
  width: 100%;
  background-color: white;
  border-radius: 1rem;
  color: #444;
  padding: 1.8rem 1.5rem 1.3rem;
  border: none;
  outline: none;
  font-size: 1.5rem;
  letter-spacing: -0.009rem;
  line-height: 1.9rem;
  font-family: Dotties, "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
`;
export const Element = styled.div `
  position: relative;
  
  ${Button}{
    position: absolute;
    right: 1.5rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`;
export default {
    Element,
    Input,
    Button,
};
